const isSelected = (tcn: string, selected: string) => {
    console.log(`batch print confirm isSelected selected: ${selected} tcn: `, tcn)
    return selected.indexOf(tcn) !== -1;  //this checks tcn which it only gets from select all
}

export { isSelected }